import React, { useState, useEffect } from "react";
import "./ProductsPageSlider.css";

import slide1 from "../../assets/Comprehensive-Industrial-Product-Portfolio.png";
import slide2 from "../../assets/Trusted-Partner-for-Specialty-Chemicals.png";
import slide3 from "../../assets/product-slider-1.png";

const slides = [
  {
    image: slide1,
title: "Trusted Partner for Industrial Needs",
    subtitle: "Delivering Quality, Reliability, and Sustainable Solutions.",
    button: "Contact Us"
  },
  {
    image: slide2,
    title: "Trusted Partner for Specialty Chemicals",
    subtitle: "Delivering Quality, Reliability, and Sustainable Solutions.",
    button: "View Chemical Solutions"
  },
  {
    image: slide3,
title: "Trusted Partner for Specialty Chemicals",
    subtitle: "Delivering Quality, Reliability, and Sustainable Solutions.",
    button: "View Chemical Solutions"
  }
];

const ProductsPageSlider = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const prevSlide = () => {
    setCurrent(current === 0 ? slides.length - 1 : current - 1);
  };

  const nextSlide = () => {
    setCurrent(current === slides.length - 1 ? 0 : current + 1);
  };

  return (
    <div className="products-page-slider-container">
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`products-page-slider-slide ${index === current ? "active" : ""}`}
        >
          {/* Image Section */}
          <div
            className="products-page-slider-image"
            style={{ backgroundImage: `url(${slide.image})` }}
          ></div>

          {/* Content Section */}
          <div className="products-page-slider-content">
            <h2 className="products-page-slider-title">{slide.title}</h2>
            <p className="products-page-slider-subtitle">{slide.subtitle}</p>
            <a href="/contact"><button className="products-page-slider-btn">{slide.button}</button></a>
          </div>
        </div>
      ))}

      {/* Controls */}
      <div className="products-page-slider-controls">
        <button className="products-page-slider-control-btn" onClick={prevSlide}>
          ‹
        </button>
        <button className="products-page-slider-control-btn" onClick={nextSlide}>
          ›
        </button>
      </div>
    </div>
  );
};

export default ProductsPageSlider;
